import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../core/signals.mjs';
import { ReactiveMutableList2gg4x024enrbf as ReactiveMutableList } from '../../core/ReactiveMutableList.mjs';
import { listOfNotNull1v4ggfackvuny as listOfNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../core/Remember.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var WarningClass;
function Warning() {
  if (WarningClass === VOID) {
    class $ {
      constructor(summary, description) {
        description = description === VOID ? summary : description;
        this.gat_1 = summary;
        this.hat_1 = description;
      }
      iat() {
        return this.gat_1;
      }
      q91() {
        return this.hat_1;
      }
      toString() {
        return 'Warning(summary=' + this.gat_1 + ', description=' + this.hat_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.gat_1);
        result = imul(result, 31) + getStringHashCode(this.hat_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Warning()))
          return false;
        if (!(this.gat_1 === other.gat_1))
          return false;
        if (!(this.hat_1 === other.hat_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Warning');
    WarningClass = $;
  }
  return WarningClass;
}
var InvalidClass;
function Invalid() {
  if (InvalidClass === VOID) {
    class $ {
      constructor(summary, description) {
        description = description === VOID ? summary : description;
        this.jat_1 = summary;
        this.kat_1 = description;
      }
      iat() {
        return this.jat_1;
      }
      q91() {
        return this.kat_1;
      }
      toString() {
        return 'Invalid(summary=' + this.jat_1 + ', description=' + this.kat_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.jat_1);
        result = imul(result, 31) + getStringHashCode(this.kat_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Invalid()))
          return false;
        if (!(this.jat_1 === other.jat_1))
          return false;
        if (!(this.kat_1 === other.kat_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Invalid');
    InvalidClass = $;
  }
  return InvalidClass;
}
function IssueNode$disconnect$ref(p0) {
  var l = () => {
    p0.qat();
    return Unit_instance;
  };
  l.callableName = 'disconnect';
  return l;
}
var IssueNodeClass;
function IssueNode() {
  if (IssueNodeClass === VOID) {
    class $ {
      constructor(parent) {
        parent = parent === VOID ? null : parent;
        this.lat_1 = parent;
        this.mat_1 = Signal().fak(new (Constant())(_Constant___init__impl__v45mub(null)));
        this.nat_1 = ReactiveMutableList().tam();
        this.oat_1 = false;
        var tmp = this;
        tmp.pat_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = listOfNotNull($this$remember.baj($this$remember.baj(this.mat_1)));
          // Inline function 'kotlin.collections.flatMap' call
          var tmp0 = $this$remember.baj(this.nat_1);
          // Inline function 'kotlin.collections.flatMapTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var list = $this$remember.baj(element.pat_1);
            addAll(destination, list);
          }
          return plus(tmp, destination);
        });
      }
      rat(issue) {
        this.mat_1.mam(new (Constant())(_Constant___init__impl__v45mub(issue)));
      }
      sat(issue) {
        this.mat_1.mam(remember(VOID, VOID, VOID, issue));
      }
      tat() {
        // Inline function 'kotlin.apply' call
        var this_0 = new (IssueNode())(this);
        this_0.uat();
        return this_0;
      }
      uat() {
        if (this.oat_1 || this.lat_1 == null)
          return Unit_instance;
        this.oat_1 = true;
        this.lat_1.nat_1.lam(this);
      }
      qat() {
        if (!this.oat_1 || this.lat_1 == null)
          return Unit_instance;
        this.oat_1 = false;
        this.lat_1.nat_1.kam(this);
      }
      iaj() {
        this.uat();
        return IssueNode$disconnect$ref(this);
      }
    }
    initMetadataForClass($, 'IssueNode', IssueNode);
    IssueNodeClass = $;
  }
  return IssueNodeClass;
}
//region block: exports
export {
  Invalid as Invalid2lchzzxcoxbzy,
  Warning as Warning3n5ye4cehejrw,
  IssueNode as IssueNode2x8c6ia7dmfdz,
};
//endregion

//# sourceMappingURL=IssueNode.mjs.map
